module.exports = __webpack_public_path__ + "static/media/emoji_open_mouth_face.1478a4d4.svg";